(function () {
  function initSlider(slider) {
    if (!slider || slider.dataset.initialized === 'true') return;

    var track = slider.querySelector('[data-topbar-text-slider-track]');
    var originalSlides = Array.prototype.slice.call(slider.querySelectorAll('.topbar-text-slider__slide'));
    if (!track || originalSlides.length === 0) return;

    slider.dataset.initialized = 'true';
    var currentIndex = originalSlides.length > 1 ? originalSlides.length : 0;
    var intervalId = null;
    var delay = Number(slider.dataset.autoplayDelay) || 4500;
    var slides = originalSlides;

    if (originalSlides.length > 1) {
      var firstClone = originalSlides[0].cloneNode(true);
      firstClone.setAttribute('data-topbar-text-slider-clone', 'true');

      track.innerHTML = '';
      track.appendChild(firstClone);
      originalSlides
        .slice()
        .reverse()
        .forEach(function (slide) {
          track.appendChild(slide);
        });

      slides = Array.prototype.slice.call(slider.querySelectorAll('.topbar-text-slider__slide'));
    }

    function enableTransition() {
      track.style.transition = '';
    }

    function disableTransition() {
      track.style.transition = 'none';
    }

    function goToSlide(index, withTransition) {
      if (withTransition === false) {
        disableTransition();
      } else {
        enableTransition();
      }

      currentIndex = index;
      track.style.transform = 'translateY(-' + currentIndex * slider.clientHeight + 'px)';
    }

    function forceReflow() {
      return track.offsetHeight;
    }

    function setHeight() {
      slider.style.height = '';
      slides.forEach(function (slide) {
        slide.style.height = '';
      });

      var maxHeight = Math.max.apply(
        Math,
        slides.map(function (slide) {
          return slide.offsetHeight;
        })
      );

      if (!maxHeight) return;

      slider.style.height = maxHeight + 'px';
      slides.forEach(function (slide) {
        slide.style.height = maxHeight + 'px';
      });
      goToSlide(currentIndex, false);
      window.requestAnimationFrame(enableTransition);
    }

    function start() {
      if (originalSlides.length < 2 || intervalId) return;
      intervalId = window.setInterval(function () {
        goToSlide(currentIndex - 1, true);
      }, delay);
    }

    function handleTransitionEnd(event) {
      if (event.target !== track || originalSlides.length < 2) return;

      if (currentIndex === 0) {
        goToSlide(originalSlides.length, false);
        forceReflow();
        enableTransition();
      }
    }

    function destroy() {
      window.clearInterval(intervalId);
      window.removeEventListener('resize', setHeight);
      track.removeEventListener('transitionend', handleTransitionEnd);
      slider.querySelectorAll('[data-topbar-text-slider-clone]').forEach(function (clone) {
        clone.remove();
      });
      slider.dataset.initialized = 'false';
    }

    setHeight();
    goToSlide(currentIndex, false);
    start();
    window.setTimeout(setHeight, 100);

    window.addEventListener('resize', setHeight);
    track.addEventListener('transitionend', handleTransitionEnd);
    slider.addEventListener('topbar-text-slider:destroy', destroy, { once: true });
  }

  function initTopbarTextSliders(container) {
    var scope = container || document;
    var sliders = scope.querySelectorAll('[data-topbar-text-slider]');
    sliders.forEach(initSlider);
  }

  function destroyTopbarTextSliders(container) {
    var scope = container || document;
    var sliders = scope.querySelectorAll('[data-topbar-text-slider]');
    sliders.forEach(function (slider) {
      slider.dispatchEvent(new CustomEvent('topbar-text-slider:destroy'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTopbarTextSliders(document);
    });
  } else {
    initTopbarTextSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTopbarTextSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyTopbarTextSliders(event.target);
  });
})();
